<template>
  <v-autocomplete
    label="Caixa"
    v-bind="$attrs"
    :dense="dense"
    v-on="$listeners"
    :items="accounts"
    :item-text="itemText"
    :item-value="itemValue"
  >
    <template v-slot:selection="{ item, index, items }">
      <template v-if="index < 3">
        <v-chip class="ma-1" small>
          {{ item.name }}
        </v-chip>
      </template>

      <template v-if="index === 3">
        <span class="grey--text text-caption ml-2">
          (+{{ $attrs.value.length - 3 }} outros)
        </span>
      </template>
    </template>
  </v-autocomplete>
</template>

<!-- <template>
  <app-select
    label="Caixa"
    v-bind="$attrs"
    :dense="dense"
    v-on="$listeners"
    :items="accounts"
    :item-text="itemText"
    :item-value="itemValue"
  />
</template> -->

<script>
export default {
  props: {
    itemText: {
      default() {
        return (val) => `${val.name}`;
      },
    },

    itemValue: {
      default() {
        return (val) => val;
      },
    },

    dense: {
      default: true,
    },
  },

  data : () => ({
    accounts : [],
  }),

  created() {
    this.select()
  },

  methods: {
    select() {
      this.$http.index('account/account').then((response) => {
        this.accounts = response.accounts;
      });
    },
  },
};
</script>